import { 
    trackPageView, 
    trackButtonClick, 
    trackSurveyClick, 
    trackSocialClick, 
} from './analytics.js';
import { loadEvents } from './events.js';

// Initialize page tracking
document.addEventListener('DOMContentLoaded', function() {
    // Track initial page view
    trackPageView('GDG Port of Spain Landing Page');
    
    // Smooth scrolling for navigation links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                
                // Track navigation clicks
                const sectionName = this.getAttribute('href').substring(1);
                trackButtonClick(`nav_${sectionName}`, 'navigation');
            }
        });
    });
    
    // Track community join clicks
    document.querySelectorAll('a[href*="gdg.community.dev"]').forEach(button => {
        button.addEventListener('click', function() {
            trackButtonClick('join_community', 'community_platform');
        });
    });

    // Track survey button clicks
    document.querySelectorAll('a[href*="forms.gle"]').forEach(button => {
        button.addEventListener('click', function() {
            trackSurveyClick();
        });
    });
    
    // Track social media clicks
    document.querySelectorAll('a[href*="twitter.com"], a[href*="facebook.com"], a[href*="linkedin.com"], a[href*="instagram.com"], a[href*="whatsapp.com"]').forEach(link => {
        link.addEventListener('click', function() {
            let platform = 'unknown';
            if (this.href.includes('twitter.com')) platform = 'twitter';
            else if (this.href.includes('facebook.com')) platform = 'facebook';
            else if (this.href.includes('linkedin.com')) platform = 'linkedin';
            else if (this.href.includes('instagram.com')) platform = 'instagram';
            else if (this.href.includes('whatsapp.com')) platform = 'whatsapp';
            
            trackSocialClick(platform);
        });
    });
    
    loadEvents();

    // Track CTA button clicks (community join tracked separately)
    document.querySelectorAll('.cta-button').forEach(button => {
        button.addEventListener('click', function() {
            if (this.href.includes('gdg.community.dev')) return;
            const buttonText = this.textContent.trim();
            trackButtonClick(buttonText, 'cta');
        });
    });
    
    // Track section views using Intersection Observer
    const observerOptions = {
        threshold: 0.5,
        rootMargin: '0px 0px -100px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const sectionName = entry.target.id || entry.target.className;
                trackPageView(`Section: ${sectionName}`);
            }
        });
    }, observerOptions);
    
    // Observe all major sections
    document.querySelectorAll('section[id], .hero-gradient').forEach(section => {
        observer.observe(section);
    });
});
